module.exports = __webpack_public_path__ + "img/right-arrow-icon.cf379f21.svg";